import Map from './components/Map';
import React, { useEffect, useState, useRef } from 'react';
import Quiz from './components/Quiz';
import Dialog from './components/Dialog';
import Cookies from 'js-cookie';
import Content from './components/Content';
import QrReader from './components/QrReader';
import './App.css';

import cover from './assets/images/cover.jpg';
import svg1 from './assets/svg/1.svg';
import svg2 from './assets/svg/2.svg';
import svg3 from './assets/svg/3.svg';
import svg4 from './assets/svg/4.svg';
import svg5 from './assets/svg/5.svg';
import svgQuiz from './assets/svg/quiz.svg';
import svgPhoto from './assets/svg/photo.svg';

function App() {
	const defaultPoints = {
		"xAbLDeaKJP": { id: 1, visited: false, x: 51, y: 65 },
		"z34tr8slsx": { id: 2, visited: false, x: 89, y: 97 },
		"LsAjfe3sPN": { id: 3, visited: false, x: 53, y: 55 },
		"asdjkw9jer": { id: 4, visited: false, x: 17, y: 13 },
		"poEFmpo34i": { id: 5, visited: false, x: 8, y: -3 },
		"yeMNcb4gko": { id: 6, visited: false, x: 34, y: 30 },
		"xmcvlpeirt": { id: 7, visited: false, x: 37, y: 45 },
		"aSmOwI20is": { id: 8, visited: false, x: 68, y: 86 },
	};

	let visitFromUrl = false;

	const getPointFromUrl = (url) => {
		const u = new URL(url);
		return u.searchParams.get('p');
	}

	const getVisitedPoints = () => {
		let ps = [];
		const p = getPointFromUrl(window.location.href);
		if (p) { ps.push(p); visitFromUrl = p; }
		const json = Cookies.get('zs_points');
		if (!json) return ps;
		const qr = JSON.parse(json);
		if (!qr) return ps;
		return [...new Set([...qr, ...ps])];
	}

	const getPoints = () => {
		let points = defaultPoints;
		const qr = getVisitedPoints();
		if (qr.length === 0) return points;
		qr.map((code) => {
			points[code].visited = true;
			return code;
		});
		return points;
	}

	const [dialogContent, setDialogContent] = useState(null);
	const [visitedPoints, setVisitedPoints] = useState(getVisitedPoints);
	const [currentPoint, setCurrentPoint] = useState(null);
	const [showDialog, setShowDialog] = useState(false);
	const [points, setPoints] = useState(getPoints);
	const [err, setError] = useState(null);
	const scrollRef = useRef(null);
	const mapRef = useRef(null);

	const processPoints = (ps, key) => {
		if (ps.hasOwnProperty(key)) {
			setCurrentPoint(ps[key].id);
			return { 
				...ps,
				[key]: {
					...ps[key],
					visited: true,
				},
			};
		}
		return -1;
	}

	const handleScan = (url) => {
		const point = getPointFromUrl(url);
		const ps = processPoints(points, point);
		if (ps !== -1) {
			setPoints(ps);
			setShowDialog(false);

			let vs = visitedPoints;
			if (!vs.includes(point)) {
				vs.push(point);
				setVisitedPoints(vs);
				Cookies.set('zs_points', JSON.stringify(vs), { expires: 30 });
			}
			scroll();
			return 0;
		}
		setError("Neplatné místo!");
		return -1;
	}

	const handleSaveQuiz = () => {
		setShowDialog(false);
	}

	const handleClickPoint = (i) => {
		setCurrentPoint(i+1);
		scroll();
	}

	const openDialog = (content) => {
		setDialogContent(content);
		setShowDialog(true);
	};

	const closeDialog = () => {
		setShowDialog(false);
	}

	const scrollTo = (ref) => {
		const scrollEl = ref.current;
		if (scrollEl) {
			scrollEl.scrollIntoView({ behavior: 'smooth' });
		}
	}

	const completedMission = () => {
		return visitedPoints.length === 8;
	}

	const scroll = () => {
		setTimeout(() => {
			scrollTo(scrollRef);
		}, 100);
	}

	const onGoUp = () => {
		scrollTo(mapRef);
	}

	useEffect(() => {
		Cookies.set('zs_points', JSON.stringify(visitedPoints), { expires: 30 });
		if (visitFromUrl) {
			setCurrentPoint(points[visitFromUrl].id);
			scroll();
		}
	}, [points, scroll, visitedPoints, visitFromUrl]);

	return (
		<div className="App">
			<header>
				<p className="mb-0"><img src={cover} alt="" /></p>
			</header>
			<div className="wrapper" ref={mapRef} style={{paddingTop: "1.5rem"}}>
				<div className="intro">
					<div className="intro-topright">
						<div className="step flex">
							<div style={{position: "absolute", top: "42%", right: "82%", width: "100%", maxWidth: "35%"}}>
								<img src={svg1} alt="" />
							</div>
							<div className="number">1.</div>
							<div>
								<h2>Najdi místo</h2>
								<p>Objevuj postupně podle čísel místa v parku, která ti odhalí vědění o stromech. Mapka ti ukazuje jejich&nbsp;polohu.</p>
							</div>
						</div>
					</div>
					<Map points={points} current={currentPoint} onClick={handleClickPoint} />
					<div className="intro-leftbottom">
						<div className="step flex">
							<div style={{position: "absolute", bottom: "100%", left: "40%", width: "100%", maxWidth: "50%"}}>
								<img src={svg2} alt="" />
							</div>
							<div className="number">2.</div>
							<div>
								<h2>Skenuj QR</h2>
								<p>Naskenuj QR kódy a dozvídej se, co&nbsp;ti&nbsp;jednotlivá místa prozradí.</p>
							</div>
							<div style={{position: "absolute", top: "110%", right: "15%", maxWidth: "27%"}}>
								<img src={svg3} alt="" />
							</div>
						</div>
					</div>
				</div>
				<div style={{padding: "2em 0", position: "relative", zIndex: 2}}>
					<div className="flex justify-space-between">
						<button onClick={() => openDialog(<QrReader onScan={handleScan} />)} className="btn-circle">
							<span>
								<img src={svgPhoto} style={{maxWidth: "35%"}} alt="" />
								Naskenovat QR Kód
							</span>
						</button>
						<button onClick={() => openDialog(<Quiz onSave={handleSaveQuiz }/>)} className="btn-circle btn-green" disabled={!completedMission()}>
							<span>
								<img src={svgQuiz} style={{maxWidth: 48 + '%'}} alt="" />
								Vyplnit kvíz
							</span>
						</button>
					</div>
					<div className="step flex" style={{marginTop: "1.5rem"}}>
						<div style={{position: "absolute", top: "-29%", right: "104%", width: "100%", maxWidth: "22%"}}>
							<img src={svg4} alt="" />
						</div>
						<div className="number">3.</div>
						<div>
							<h2>Najdi je všechny</h2>
							<p>Až posbíráš všech 8 míst, dozvíš se o tajném životě stromů a můžeš si zkusit malý kvíz.</p>
						</div>
						<div style={{position: "absolute", top: "-20%", left: "98%", width: "100%", maxWidth: "24%"}}>
							<img src={svg5} alt="" />
						</div>
					</div>
				</div>
			</div>
			<div ref={scrollRef}>
				<Content point={currentPoint} onGoUp={onGoUp} />
			</div>
			<Dialog onClose={closeDialog} showDialog={showDialog} setShowDialog={setShowDialog}>
				{dialogContent}
			</Dialog>
		</div>
	);
}

export default App;
